import { convertHsvToRgb, serializeHex } from 'culori/fn';

export function socColor(soc: number): string {
  const value = Math.max(0, Math.min(1, soc));

  return serializeHex(
    convertHsvToRgb({
      h: 128,
      s: value * 0.9 + 0.1,
      v: 0.9 - value * 0.4,
    }),
  );
}
